var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { UitkCheckbox } from 'uitk-react-checkbox';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkHeading } from 'uitk-react-text';
import { useStores } from '../../../utils/hooks';
import { checkboxClickHandler, PRICE_CATEGORY, seeAllCheckboxClickHandler, SEE_ALL_CATEGORY } from './filter-helper';
import { rangeCheckboxClickHandler } from './range-filter-helper';
export var getCheckboxKeyAndId = function (key) {
  var _a = __read(key.split('-'), 3),
    filterKey = _a[1],
    filterCategoryId = _a[2];
  return {
    filterKey: filterKey,
    filterCategoryId: filterCategoryId
  };
};
export var Checkbox = observer(function (_a) {
  var _b;
  var inDialog = _a.inDialog,
    field = _a.field;
  var _c = useStores(),
    analytics = _c.analytics,
    activitySearchStore = _c.activitySearchStore;
  var history = useHistory();
  var location = useLocation();
  var categoryName = field.primary || undefined;
  var filterOptions = activitySearchStore.sortAndFilterObject.filters;
  function updateCheckbox(event, clientSideAnalytics) {
    activitySearchStore.searchSetup();
    var filterKey = event.target.name;
    var filterCategoryId = getCheckboxKeyAndId(event.target.id).filterCategoryId;
    analytics.trackEvent(clientSideAnalytics === null || clientSideAnalytics === void 0 ? void 0 : clientSideAnalytics.referrerId, clientSideAnalytics === null || clientSideAnalytics === void 0 ? void 0 : clientSideAnalytics.linkName);
    if (filterCategoryId === SEE_ALL_CATEGORY) {
      seeAllCheckboxClickHandler(filterKey, filterCategoryId, activitySearchStore, history, location, event, inDialog);
    } else if (filterCategoryId === PRICE_CATEGORY) {
      rangeCheckboxClickHandler(activitySearchStore, event, history, location, inDialog);
    } else {
      checkboxClickHandler(filterKey, filterCategoryId, activitySearchStore, history, location, event, inDialog);
    }
  }
  var renderSubCategories = function (checked, categoryId, subCategoryTitle, subFilterProps) {
    if (!checked || !subFilterProps) {
      return null;
    }
    return React.createElement(UitkSpacing, {
      padding: {
        inlinestart: 'four'
      },
      margin: {
        inlinestart: 'four'
      }
    }, React.createElement("fieldset", {
      "data-testid": "filter--subcategory-options"
    }, React.createElement("legend", {
      className: "is-visually-hidden"
    }, subCategoryTitle), subFilterProps === null || subFilterProps === void 0 ? void 0 : subFilterProps.map(function (subProps) {
      var _a, _b, _c;
      return React.createElement("div", {
        key: "child-category-".concat(subProps.value),
        "data-testid": "filter--subcategory-options-checkbox"
      }, React.createElement(UitkCheckbox, {
        id: "cb-".concat(subProps.value, "-").concat(categoryId),
        name: subProps.value,
        description: subProps.description || '',
        value: ((_a = filterOptions[categoryId][subProps.value]) === null || _a === void 0 ? void 0 : _a.selected) || '',
        checked: ((_b = filterOptions[categoryId][subProps.value]) === null || _b === void 0 ? void 0 : _b.selected) || false,
        disabled: !((_c = filterOptions[categoryId][subProps.value]) === null || _c === void 0 ? void 0 : _c.enabled) || false,
        onChange: function (event) {
          return updateCheckbox(event, subProps.selected ? subProps.deselectAnalytics : subProps.selectAnalytics);
        }
      }, subProps.primary));
    })));
  };
  return React.createElement(React.Fragment, null, React.createElement("fieldset", {
    key: categoryName
  }, categoryName ? React.createElement(UitkSpacing, {
    padding: {
      blockstart: 'four',
      blockend: 'two'
    }
  }, React.createElement("legend", {
    "data-testid": "filter--category-name"
  }, React.createElement(UitkHeading, {
    tag: "h5",
    size: 6
  }, categoryName))) : null, (_b = field === null || field === void 0 ? void 0 : field.options) === null || _b === void 0 ? void 0 : _b.map(function (option) {
    var _a, _b, _c, _d;
    return React.createElement("div", {
      key: "parent-category-".concat(option.value),
      "data-testid": "filter--".concat(option.id, "-options")
    }, React.createElement(UitkCheckbox, {
      id: "cb-".concat(option.value.replace(/ /g, ''), "-").concat(option.id),
      name: option.value,
      description: option.description || '',
      value: ((_a = filterOptions[option.id][option.value]) === null || _a === void 0 ? void 0 : _a.selected) || '',
      checked: ((_b = filterOptions[option.id][option.value]) === null || _b === void 0 ? void 0 : _b.selected) || false,
      disabled: !((_c = filterOptions[option.id][option.value]) === null || _c === void 0 ? void 0 : _c.enabled) || false,
      onChange: function (event) {
        return updateCheckbox(event, option.selected ? option.deselectAnalytics : option.selectAnalytics);
      },
      "data-testid": "filter--".concat(option.id, "-options-checkbox")
    }, option.accessibility && React.createElement("span", {
      className: "is-visually-hidden"
    }, option.accessibility), React.createElement("span", {
      "aria-hidden": Boolean(option.accessibility)
    }, option.primary)), renderSubCategories((_d = filterOptions[option.id][option.value]) === null || _d === void 0 ? void 0 : _d.selected, option.id, option.primary, option.nestedOptions));
  })));
});